<template>
  <div class="Container">
    <div class="Window">
      <div class="Caption">
        <p class="Caption_Text">
          {{ $t('code-caption') }}
        </p>
      </div>
      <div class="CodeContainer">
        <div class="InputContainer">
          <input
            ref="input01"
            v-model="field01"
            class="Input"
            maxlength="4"
            type="text"
            @keyup="SwitchField(1)"
            @keydown="SwitchFieldUp(1)"
          >
          <div class="Input_Caption">
            <p class="Input_Caption_Text">
              A123
            </p>
          </div>
        </div>
        <div class="InputContainer">
          <input
            ref="input02"
            v-model="field02"
            class="Input"
            maxlength="4"
            type="text"
            @keyup="SwitchField(2)"
            @keydown="SwitchFieldUp(2)"
          >
          <div class="Input_Caption">
            <p class="Input_Caption_Text">
              4567
            </p>
          </div>
        </div>
        <div class="InputContainer">
          <input
            ref="input03"
            v-model="field03"
            class="Input"
            maxlength="4"
            type="text"
            @keyup="SwitchField(3)"
            @keydown="SwitchFieldUp(3)"
          >
          <div class="Input_Caption">
            <p class="Input_Caption_Text">
              8910
            </p>
          </div>
        </div>
        <div class="InputContainer">
          <input
            ref="input04"
            v-model="field04"
            class="Input"
            maxlength="4"
            type="text"
            @keyup="SwitchField(4)"
            @keydown="SwitchFieldUp(4)"
          >
          <div class="Input_Caption">
            <p class="Input_Caption_Text">
              1234
            </p>
          </div>
        </div>
        <div class="InputContainer">
          <input
            ref="input05"
            v-model="field05"
            class="Input"
            maxlength="4"
            type="text"
            @keyup="SwitchField(5)"
            @keydown="SwitchFieldUp(5)"
          >
          <div class="Input_Caption">
            <p class="Input_Caption_Text">
              5678
            </p>
          </div>
        </div>
        <div class="InputContainer">
          <input
            ref="input06"
            v-model="field06"
            class="Input"
            maxlength="4"
            type="text"
            @keyup="SwitchField(6)"
            @keydown="SwitchFieldUp(6)"
          >
          <div class="Input_Caption">
            <p class="Input_Caption_Text">
              9101
            </p>
          </div>
        </div>
        <div class="InputContainer">
          <input
            ref="input07"
            v-model="field07"
            class="Input"
            maxlength="3"
            type="text"
            @keyup="SwitchField(7)"
            @keydown="SwitchFieldUp(7)"
          >
          <div class="Input_Caption">
            <p class="Input_Caption_Text">
              424
            </p>
          </div>
        </div>
      </div>
      <div class="Caption_warning">
        <p
          v-show="!valid"
          class="Warning_Text"
        >
          {{ $t('code-invalid') }}
        </p>
      </div>
      <div class="Buttons">
        <button
          class="Button"
          @click="Close()"
        >
          {{ $t('navigation-warning-cancel') }}
        </button>
        <button
          class="Button_Black"
          @click="Confirm()"
        >
          {{ $t('navigation-warning-confirm') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import tables from '@/settings/tables.json'
import { mapGetters } from 'vuex'
import { ValidateCode } from './CodeValidator'

export default {
  data () {
    return {
      valid: true,
      pressed: false,
      field01: '',
      field02: '',
      field03: '',
      field04: '',
      field05: '',
      field06: '',
      field07: ''
    }
  },
  computed: {
    ...mapGetters(['isDebug'])
  },
  mounted () {
    window.addEventListener('paste', this.HandlePaste)
  },
  beforeDestroy () {
    window.removeEventListener('paste', this.HandlePaste)
  },
  methods: {
    Close () {
      this.$store.dispatch('SetCode', false)
    },
    ConcatString () {
      let result = this.field01.concat(this.field02)
      result = result.concat(this.field03)
      result = result.concat(this.field04)
      result = result.concat(this.field05)
      result = result.concat(this.field06)
      result = result.concat(this.field07)
      return result
    },
    Confirm () {
      this.valid = true
      let result = ''
      result = this.ConcatString()
      if (result === 'bweez') {
        this.$store.dispatch('SetDebug', true)
        this.Close()
        return
      }
      const code = ValidateCode(result)
      if (code === null) {
        this.valid = false
      } else {
        this.$store.dispatch('SetStep', 3)
        this.$store.dispatch('SetTable', tables[code.type])
        this.$store.dispatch('SetSliders', code.rotations)
        this.$store.dispatch('SetUVs', code.uvs)
        this.$store.dispatch('SetForces', code.forces)
        this.Close()
      }
    },
    SwitchField (index) {
      if (!this.pressed) return
      if (this.$refs['input0' + index].value.length === parseInt(this.$refs['input0' + index].attributes.maxlength.value) &&
      this.$refs['input0' + index].selectionStart === this.$refs['input0' + index].value.length) {
        if (this.$refs['input0' + (index + 1)]) {
          this.$refs['input0' + (index + 1)].focus()
        }
      }
      if (this.$refs['input0' + index].value.length === 0) {
        if (this.$refs['input0' + (index - 1)]) {
          this.$refs['input0' + (index - 1)].focus()
        }
      }
      this.pressed = false
    },
    SwitchFieldUp (index) {
      this.pressed = true
    },
    HandlePaste (event) {
      let paste = (event.clipboardData || window.clipboardData).getData('text')
      paste = paste.replace(/\s/g, '')
      if (paste.length === 27) {
        this.field01 = ''
        this.field02 = ''
        this.field03 = ''
        this.field01 = paste.substr(0, 4)
        this.field02 = paste.substr(4, 4)
        this.field03 = paste.substr(8, 4)
        this.field04 = paste.substr(12, 4)
        this.field05 = paste.substr(16, 4)
        this.field06 = paste.substr(20, 4)
        this.field07 = paste.substr(24, 3)
      }
    }
  }
}
</script>

<style scoped>
.Container{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  background: rgb(0,0,0,0.4)
}

.Window{
  margin: auto;
  margin-top: 15em;
  width: 30em;
  height: auto;
  background: white;
  border-radius: 10px;
  box-sizing: border-box;
  padding-left: 0.5em;
  padding-right: 0.5em;
}

.Caption {
  width: 100%;
  margin: 1em 0em 1em 0em;
  display: flex;
  justify-content: center;
}

.Caption_Text {
  margin: auto;
  text-align: center;
}

.Buttons{
 display: flex;
 flex-direction: row;
 justify-content: center;
 margin-bottom: 1em;
}

.Button {
  width: 130px;
  height: 32px;
  background: white;
  margin-right: 1em;
  border-radius: 5px;
  border: 1px solid black;
  font-size: 0.8em;
}

.Button_Black {
  width: 130px;
  height: 32px;
  background: black;
  color: white;
  border-radius: 5px;
  font-size: 0.8em;
}

.Caption_warning {
  width: 100%;
  margin: 0.5em 0em 0.5em 0em;
  height: 1em;
  display: flex;
  justify-content: center;
}

.Warning_Text{
  color: red;
  font-weight: 200;
  font-size: 0.9em;
}

.CodeContainer{
  display: flex;
  flex-direction: row;
  justify-content: center;
  display: flex;
  padding-left: 1em;
  padding-right: 1em;
}

.InputContainer{
  flex:1;
  padding-left: 0.5em;
  padding-right: 0.5em;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.Input{
  width:100%;
}

.Input_Caption{
  display: flex;
  justify-content: flex-start;
}

.Input_Caption_Text{
  margin-top: 0.5em;
  text-align: center;
  color: gray;
  font-size: 0.8em;
  font-weight: 200;
}

.InputContainerDebug {
  margin-top: 10px;
  width: 95%;
  margin-left: 10px;
}
</style>
